import React, { useState } from "react";
import { Tab, Nav, Row, Col, Container } from "react-bootstrap";
import "./Login.css";
import Customer_Login from "./customer-login/Customer_Login";
import Vendor_Login from "./vendor-login/Vendor_Login";
import Expert_Login from "./expert-login/Expert_Login";

const Login = () => {
  const [activeTab, setActiveTab] = useState("Customer");

  return (
    <div className="login-page-wrapper">
      <Container fluid className="p-0  overflow-hidden">
        <Row className="g-0">
          <Col lg={3} md={4} className="d-none d-md-block p-0">
            <div className="login-hero-section">
              <img
                src="/assets/images/login-page-img.png"
                alt="Worker at warehouse"
                className="hero-img"
              />
            </div>
          </Col>

          <Col
            lg={9}
            md={8}
            xs={12}
            className="d-flex align-items-center justify-content-center login-form-section"
          >
            <div className="login-form-container">
              <h2 className="welcome-title">Welcome to OII TYPE SERVICES</h2>
              <p className="auth-subtitle">Log in / Sign Up</p>

              <Tab.Container
                activeKey={activeTab}
                onSelect={(k) => setActiveTab(k)}
              >
                <div className="tabs-navigation-wrapper">
                  <Nav variant="pills" className="custom-nav-pills">
                    <Nav.Item>
                      <Nav.Link eventKey="Customer">Customer</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="Vendor">Vendor</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="Expert">Expert</Nav.Link>
                    </Nav.Item>
                  </Nav>
                </div>
                <div className="login-card-shadow">
                  <Tab.Content>
                    <Tab.Pane eventKey="Customer">
                      <Customer_Login activeTab={activeTab} />
                    </Tab.Pane>
                    <Tab.Pane eventKey="Vendor">
                      <Vendor_Login activeTab={activeTab} />
                    </Tab.Pane>
                    <Tab.Pane eventKey="Expert">
                      <Expert_Login activeTab={activeTab} />
                    </Tab.Pane>
                  </Tab.Content>
                </div>
              </Tab.Container>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Login;
